module.exports = __webpack_public_path__ + "img/bgr-sizzle.38bcbb16.png";